'use strict';
import angular from 'angular';
import _ from 'lodash';

angular.module('workflowclient.services', ['core.iohelper'])
    .factory('WorkflowClientService', WorkflowClientService)
    .factory('WorkflowClientFactory', WorkflowClientFactory);

/**
 * @ngInject
 */
function WorkflowClientService(
    WorkflowClientFactory,
    $q,
    $rootScope,
    Upload,
    AppConfig,
    $http
) {
    let service = {};

    service.getStepsForClient = function(clientId) {
        let deferred = $q.defer();
        let params = {
            'clientId': clientId
        };

        WorkflowClientFactory.stepsForClient().get(params).$promise.then(function (data) {
            deferred.resolve(data.workflowSteps);
        }, function (response) {
            console.log("Error getting steps for client " + clientId + ": " + response);
            deferred.reject();
        });

        return deferred.promise;
    };

    // Get client activity log
    service.getClientActivity = function(clientId) {
        let deferred = $q.defer();
        let params = {
            'tableRowId': clientId
        };
        WorkflowClientFactory.clientActivity().get(params).$promise.then(function(data) {
            deferred.resolve(data.activityLogEntries);
        }, function(response) {
            console.log("Error getting activity log for client " + clientId + ": " + response);
            deferred.reject();
        });
        return deferred.promise;
    };

    return service;
}

/**
 * @ngInject
 */
function WorkflowClientFactory($resource, AppConfig) {
    let factory = {};

    factory.stepsForClient = function() {
        return $resource(AppConfig.IO_API_URL + 'workflows/workflowStepsForClient', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.clientActivity = function() {
        return $resource(AppConfig.IO_API_URL + 'activityLogs/activityLogForEntityAndRow', {
            'tableName': 'client'
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    return factory;
}
